// eslint-disable-next-line import/no-unresolved
class DescriptionStats extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '-200px 0px -200px 0px',
      threshold: [0, 1],
    })

    this.observer.observe(this)
  }

  setupListeners () {
    super.setupListeners()

    this.triggerStats = this.triggerStats.bind(this)
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.triggerStats()
  }

  triggerStats () {
    let count = 1

    this.els.usp.elements.forEach((uspEl) => {
      const statAmount = parseInt(uspEl.dataset.stat)
      const paths = uspEl.querySelectorAll(this.els.path.selector)

      paths.forEach((path, index) => {
        if (index < statAmount) {
          setTimeout(() => {
            path.setAttribute('aria-hidden', false)
          }, count * 200)
          count++
        }
      })
    })
  }
}

if (!customElements.get('description-stats')) {
  customElements.define('description-stats', DescriptionStats)
}
